export const generateTraceId = () =>
	`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
